import React from 'react'
import styled, { css } from 'styled-components'

import config from '../config'

const StyledButton = styled.a`
  display: inline-block;
  background: ${config.colors.lightblue};
  padding: 17px 47px;
  color: #fff;
  text-decoration: none;
  font-family: 'BentonSans';
  font-weight: bold;
  letter-spacing: 0.04em;
  transition: all 0.35s ease;
  text-align: center;
  line-height: 1.2;
  border: 3px solid ${config.colors.lightblue};
  cursor: pointer;
  outline: none;

  &:hover {
    background: transparent;
    color: ${config.colors.lightblue};
  }

  @media (max-width: 580px) {
    padding: 16px 32px;
    font-size: 17px;
    letter-spacing: 0.02em;
  }

  ${props =>
    props.theme.name === 'green' &&
    css`
      color: #fff;
      background: ${config.colors.lightblue};
      border-color: ${config.colors.lightblue};
    `}

  ${props =>
    props.theme.name === 'payback' &&
    css`
      font-family: 'PAYBACK_Regular';
      font-weight: normal;
      color: #fff;
      background: ${config.colors.red};
      border-color: ${config.colors.red};

      &:hover {
        color: ${config.colors.red};
      }
    `}

  ${props =>
    props.negative &&
    props.theme.name === 'blue' &&
    css`
      background: #fff;
      color: ${config.colors.blue};
      border-color: #fff;

      &:hover {
        background: transparent;
        border-color: #fff;
        color: #fff;
      }
    `}

  ${props =>
    props.negative &&
    css`
      background: #fff !important;
      color: ${config.colors.blue};
      border-color: #fff;

      &:hover {
        background: transparent !important;
        border-color: #fff;
        color: #fff;
      }
    `}

  ${props =>
    props.small &&
    css`
      padding: 20px;
      font-size: 15px;

      @media (max-width: 580px) {
        padding: 16px 20px;
        font-size: 14px;
      }
    `}

  ${props =>
    props.color === 'blue' &&
    css`
      background: ${config.colors.blue};
      color: #fff;
      border-color: ${config.colors.blue};

      &:hover {
        background: transparent;
        border-color: ${config.colors.blue};
        color: ${config.colors.blue};
      }
    `}

  ${props =>
    props.size === 'multi' &&
    css`
      padding: 14px 36px;
      font-size: 20px;

      @media (max-width: 1340px) {
        font-size: 18px;
        padding-left: 30px;
        padding-right: 30px;
      }

      @media (max-width: 1024px) {
        padding-left: 20px;
        padding-right: 20px;
        font-size: 16px;
      }
    `}

    ${props =>
      props.color === 'whitelightblue' &&
      css`
        background: #fff;
        color: ${config.colors.lightblue};
        border-color: #fff;

        &:hover {
          background: transparent;
          border-color: #fff;
          color: #fff;
        }
      `}
`

class Button extends React.Component {
  state = {
    href: '',
  }

  componentDidMount() {
    this.setState({
      href: this.props.href,
    })
  }

  render() {
    return (
      <StyledButton {...this.props} href={this.state.href} target="_blank">
        {this.props.children}
      </StyledButton>
    )
  }
}

export default Button
